import Menu, { MenuProps } from '@mui/material/Menu'
import React from 'react'
import {
    getAnchorOrigin,
    getArrowPosition,
    getMargin,
    getTransformOrigin,
} from '../utils'
import { MenuContext } from './MenuRoot'

interface MenuPopoverProps extends Omit<MenuProps, 'open' | 'anchorEl' | 'id'> {
    children: React.ReactNode
}

export default function MenuPopover({ children, ...props }: MenuPopoverProps) {
    return (
        <MenuContext.Consumer>
            {({ id, open, anchorEl, handleClose, position, arrow }) => (
                <Menu
                    id={id + '-menu'}
                    anchorEl={anchorEl}
                    open={open}
                    aria-labelledby={id + '-trigger'}
                    anchorOrigin={getAnchorOrigin(position)}
                    transformOrigin={getTransformOrigin(position)}
                    onClose={handleClose}
                    {...props}
                    slotProps={{
                        paper: {
                            ...props?.slotProps?.paper,
                            ...(arrow && {
                                elevation: 3,
                                sx: theme => ({
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-expect-error
                                    ...props?.slotProps?.paper?.sx,
                                    ...getMargin(position),
                                    overflowX: 'unset',
                                    overflowY: 'unset',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.25))',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        ...getArrowPosition(position, anchorEl),
                                        width: 10,
                                        height: 10,
                                        backgroundColor:
                                            theme.palette.background.default,
                                        boxShadow: theme.shadows[1],
                                        clipPath:
                                            'polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))',
                                    },
                                }),
                            }),
                            className: props?.className,
                        },
                    }}
                >
                    {children}
                </Menu>
            )}
        </MenuContext.Consumer>
    )
}
